import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Badge } from "antd";
import { varValue } from "common/var";
import { getPageTitle } from "common/menu";
import { callPostApiWithAuth } from "utils/api";
import { Dropdown, Menu, PpPopupModal } from "components/common";
import SideCart from "components/common/cart/SideCart";
import Notifications from "./notifications/Notifications";
import MessageBadge from "./message/MessageBadge";
import VerificationModal from "./verification/VerificationModal";
import LangBadge from "./LangBadge";
import {
  MenuOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
} from "@ant-design/icons";
import NoPhotoImg from "assets/icons/nueva/icons/avatar.svg";
import LogIcon from "assets/icons/nueva/icons/logout.svg";
import LineImg from "assets/icons/nueva/icons/line.png";
import ShoppingCartIcon from "assets/icons/header/shopping-cart.svg";
import NewCartIcon from "assets/images/v2/new-cart-icon.svg";

export default function TopHeader({ showDrawer }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const isCollapse = useSelector((state) => state.ui.isCollapse);
  const myUser = useSelector((state) => state.auth.user);
  const sudoName = useSelector((state) => state.auth.sudoName);
  const orderDetails = useSelector((state) => state.checkout.orderDetails);
  const shippingInfo = useSelector((state) => state.checkout.shippingInfo);
  const [orderCount, setOrderCount] = useState(0);
  const [shippingPrice, setShippingPrice] = useState(undefined);
  const [tax, setTax] = useState(undefined);
  const [isCreditWallet, setIsCreditWallet] = useState(false);
  const [hasPhysicalOrder, setHasPhysicalOrder] = useState(false);
  const [route, setRoute] = useState({
    //--> It can be replaced with useRef or localStorage
    to: location.pathname,
    from: location.pathname, //--> previous pathname
  });

  useEffect(() => {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");
    script2.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    const inlineScript =
      document.createTextNode(`function googleTranslateElementInit() {
        new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
      }`);
    script1.appendChild(inlineScript);
    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }, []);

  const onClickAccountMenu = ({ key }) => {
    if (key == "logout") {
      history.push("/logout");
    }
    history.push(key);
  };

  const handleShowCart = () => {
    if (location.pathname && location.pathname === "/checkout") {
      dispatch({
        type: "ui.HIDE_SIDE_CART",
      });
    } else {
      dispatch({
        type: "ui.SHOW_SIDE_CART",
      });
    }
  };


  const onSuccessGetShippingAndTax = ({ data }) => {
    setShippingPrice(data.shipping_price);
    setTax(data.tax_cost);
  };

  const onFailedShippingAndTax = (err) => {
    setShippingPrice(undefined);
    setTax(undefined);
  };

  const loadShippingInfo = () => {
    const data = {
      country: shippingInfo.shipping_country,
      state: shippingInfo.shipping_state,
      shippingDetail: shippingInfo,
      orderDetails: orderDetails.map((el) => ({
        ...el,
        product_id: el.product.id,
      })),
    };
    callPostApiWithAuth(
      "create_member/get_shipping_price",
      data,
      onSuccessGetShippingAndTax,
      onFailedShippingAndTax
    );
  };


  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      document.getElementById("localize-widget")
    ) {
      if (sudoName) {
        document.getElementById("localize-widget").style.display = "none";
      } else {
        document.getElementById("localize-widget").style.display = "block";
      }
    }
  }, [sudoName]);

  useEffect(() => {
    let orderCount_ = 0;
    for (let order of orderDetails) {
      orderCount_ += order.quantity * 1;
    }
    setOrderCount(orderCount_);

    if (
      orderDetails.length > 0 &&
      orderDetails.filter(
        (el) => el.product.type * 1 === varValue("product.type", "physical") * 1
      ).length > 0
    ) {
      setHasPhysicalOrder(true);
    } else if (
      orderDetails.length > 0 &&
      orderDetails.filter(
        (el) => el.product.type * 1 === varValue("product.type", "physical") * 1
      ).length === 0
    ) {
      setHasPhysicalOrder(false);
    } else if (orderDetails.length === 0) {
      setHasPhysicalOrder(false);
    }
  }, [orderDetails]);

  useEffect(() => {
    if (
      isCreditWallet &&
      orderDetails.length > 0 &&
      shippingInfo &&
      hasPhysicalOrder
    ) {
      loadShippingInfo();
    } else {
      setShippingPrice(undefined);
      setTax(undefined);
    }
  }, [orderDetails, shippingInfo, hasPhysicalOrder, isCreditWallet]);

  useEffect(() => {
    setRoute((prev) => ({ to: location.pathname, from: prev.to }));
    if (
      location &&
      location.pathname &&
      location.pathname === "/my_account/credit_wallet"
    ) {
      setIsCreditWallet(true);
    } else {
      setIsCreditWallet(false);
      setHasPhysicalOrder(false);
      dispatch({
        type: "checkout.CLEAR_SHIPPING_INFO",
      });
    }
  }, [location]);

  useEffect(() => {
    if (
      route &&
      route.from &&
      (route.from === "/my_account/credit_wallet" || route.from === "/checkout")
    ) {
      dispatch({
        type: "checkout.CLEAR_CART",
      });
    }
  }, [route]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (
        document.getElementById("localize-widget") &&
        document.getElementsByClassName("avatar-container").length > 0
      ) {
        let localizeSelector = document.getElementById("localize-widget");
        let avatarContainerSelector =
          document.getElementsByClassName("avatar-container")[0];

        localizeSelector.style.right =
          avatarContainerSelector.clientWidth + 70 + "px";
      }
    }
  }, []);

  return (
    <Wrapper>
      <div className="route-title">
        <span className="mobile-side-icon">
          <MenuOutlined onClick={showDrawer} />
        </span>

        {getPageTitle(history.location.pathname, myUser) ||
          history.location.pathname?.split("/")[1]?.replace("_", " ")}
      </div>

      <div className="google-set">
        <div id="google_translate_element" />
        <i className="fa fa-angle-down custom-arrow custom-arrow-lang"></i>
      </div>

      <div className="avatar-container">
        <div className="line-break">
          <img src={LineImg} />{" "}
        </div>
        <Badge count={orderCount} className="cart-badge">
          <a href="javascript:void(0)" onClick={handleShowCart}>
            <img src={NewCartIcon} />
          </a>
        </Badge>
        <Notifications/>
        <Dropdown
          placement="bottomRight"
          trigger="click"
          overlayClassName="user-menus"
          arrow={true}
          overlay={
            <Menu onClick={onClickAccountMenu}>
              <Menu.Item key="javascript:void(0)">
                <div className="user-dropdown-container">
                  <div className="user-title">
                    {`${myUser.first_name} ${myUser.last_name}`}
                  </div>
                  <div className="user-id">#{myUser.uuid}</div>
                </div>
              </Menu.Item>
              <div className="user-submenus-dropdown">
                <Menu.Item
                  onClick={() =>
                    onClickAccountMenu({ key: "/my_account/subscription" })
                  }
                >
                  Subscriptions
                </Menu.Item>
                <Menu.Item
                  onClick={() =>
                    onClickAccountMenu({ key: "/my_account/order_history" })
                  }
                >
                  Order History
                </Menu.Item>
                <Menu.Item
                  onClick={() =>
                    onClickAccountMenu({ key: "/my_account/credit_wallet" })
                  }
                >
                  Credit Wallet
                </Menu.Item>
                <Menu.Item
                  onClick={() =>
                    onClickAccountMenu({ key: "/my_account/payment_option" })
                  }
                >
                  Payment Options
                </Menu.Item>
                <Menu.Item
                  onClick={() =>
                    onClickAccountMenu({ key: "/my_account/setting" })
                  }
                >
                  Account Settings
                </Menu.Item>
                <Menu.Item
                  onClick={() => onClickAccountMenu({ key: "logout" })}
                >
                  Log Out
                </Menu.Item>
              </div>
            </Menu>
          }
        >
          <div className="avatar-box">
            <div className="admin">
              {myUser.image ? (
                <img src={myUser.image} />
              ) : (
                <>
                  <img src={NoPhotoImg} />{" "}
                  <div className="admin-text">
                    <div className="title">{myUser.first_name} {myUser.last_name}</div>
                    <div className="sub-title">#{myUser.uuid}</div>
                  </div>
                </>
              )}
            </div>
          </div>
        </Dropdown>

      </div>
      <SideCart
        shippingPrice={shippingPrice}
        tax={tax}
        isCreditWallet={isCreditWallet}
      />
      <VerificationModal />
      <PpPopupModal visible={myUser.should_show_pp_popup} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 11px 40px;
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  column-gap: 16px;
  background: #0abab5;

  @media (max-width: 900px) {
    padding: 6px 16px;
  }
  .route-title {
    font-family: "Garet-Book", sans-serif !important;
    font-weight: 600;
    font-size: 18px;
    color: #f9f6f0;
    text-transform: capitalize;
    font-family: "Garet";
    line-height: 1.2em;
    display: flex;
    align-items: center;
    .anticon {
      position: relative;
      top: -4px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .google-set {
    position: relative;
    display: flex;
    align-items: center;
    justify-self: end;
  }
  .admin {
    display: flex;
    justify-content: center;
    align-items: center;
    .admin-text {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      margin-left: 10px;
      .title {
        font-family: "Garet-Book", sans-serif !important;
        font-weight: 700;
        font-size: 14px;
        line-height: 10px;
        color: #f9f6f0;
      }
      .sub-title {
        color: #f9f6f0;
        font-family: "Inter";
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .shop-now-button {
    display: flex;
    width: 110px;
    background-color: white;
    color: black;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    height: 36px;
    justify-content: center;
    align-items: center;
  }

  .logout {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    cursor: pointer;
    img {
      width: 20px;
    }
  }
  .line-break {
    margin: 0px 16px;
    img {
      width: 2px;
      height: 40px;
    }
  }
  .sudo-badge {
    background-color: #f5222d;
    font-size: 14px;
    margin-right: 32px;
    height: 28px;
    line-height: 28px;
    padding: 0 6px;
    color: #fff;
  }
  .avatar-container {
    display: flex;
    align-items: center;
    .avatar-icons {
      width: 25px;
      margin-right: 35px;
      cursor: pointer;
    }
    .avatar-icons-hidden {
      width: 35px;
      display: inline;
    }
    .avatar-box {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 20px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
      }
      .user-container {
        .user-title {
          height: 20px;
          font-family: "Roboto", sans-serif;
          line-height: 25px;
          color: #212529;
          font-weight: 500;
          font-size: 14px;
        }
        .user-id {
          height: 20px;
          font-family: "Roboto", sans-serif;
          line-height: 20px;
          color: #7f8fa3;
          font-weight: 400;
          font-size: 12px;
        }
      }
    }
  }
  .cart-badge {
    .cart-img {
      margin-right: 0;
    }
  }
  .notification-badge {
    cursor: pointer;
    .ant-scroll-number {
      top: 2px;
      right: 2px;
      background: #ff5630;
    }
  }
  .mobile-side-icon {
    display: none;
  }
  .mobile-collapse-icon {
    display: inline;
  }
  .react-country-flag {
    border-radius: 50%;
    margin-right: 35px;
    display: inline;
  }
  @media (max-width: 1000px) {
    .route-title {
      font-size: 19px;
    }
  }
  @media (max-width: 900px) {
    .mobile-side-icon {
      display: inline;
    }
    .mobile-collapse-icon {
      display: none;
    }
  }
  @media (max-width: 800px) {
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto;
    row-gap: 0;
    padding-bottom: 2px;

    .route-title {
      grid-column: 1;
      grid-row: 1;
    }

    .avatar-container {
      grid-column: 2;
      grid-row: 1;
      justify-self: end;
    }

    .google-set {
      grid-column: 1 / -1;
      grid-row: 2;
      width: 100%;
      height: auto;
      min-height: 0;
      justify-content: center;
      justify-self: center;
      align-items: center;
      padding: 0;
      margin: 0;
      border-top: 1px solid rgba(249, 246, 240, 0.2);

      #google_translate_element {
        height: auto;
        line-height: 1;
      }
    }

    .admin .admin-text {
      display: none;
    }
  }
  @media (max-width: 900px) {
    .react-country-flag {
      display: none !important;
    }
    .avatar-icons-hidden {
      display: none !important;
    }
  }
  @media (max-width: 575px) {
    .cart-badge {
      margin-right: 5px;
    }
    .user-container {
      display: none;
    }
    .avatar-container {
      .avatar-box {
        margin-left: 8px;
        img {
          width: 28px;
          height: 28px;
          margin-right: 0;
        }
      }
    }
  }
`;
